import React from 'react'
import { Route, Routes } from "react-router-dom";
import EntreprisesPage from '../../pages/features/entreprises/EntreprisesPage';




export default function EntrepriseNav() {
  return (
    <Routes>
      <Route path="/" element={<EntreprisesPage />} />
   
    </Routes>
  );
}
